import React  from 'react';
import ListOptions from './ListOptions';
import socketIOClient from "socket.io-client";
import {
    withRouter
} from 'react-router-dom';
import axios from 'axios';
import Icon from '@mdi/react'
import { mdiArrowCollapseLeft } from '@mdi/js';
import { mdiArrowExpandRight } from '@mdi/js';
class SideBar extends React.Component{

    constructor(props){
        super(props);
        this.state = {
            pages:[

            ]
        }


        this.parent = null;


        
        
    }


    emojilit = (num) =>{


        var emojis = ["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","kiwifruit","tomato","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","cucumber","leafy_green","broccoli","garlic","onion","mushroom","peanuts","chestnut","bread","croissant","baguette_bread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","cup_with_straw","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","amphora","jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","8ball","crystal_ball","nazar_amulet","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","yarn","earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","busstop","motorway","railway_track","oil_drum","fuelpump","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]


        return emojis[num];

    }



    componentDidMount = () => {

        this.setState(this.props.list);
        console.log(this.state);
    }

    handleNewPage = (event) =>{
        const value = localStorage.getItem('uid');
        const ids = Math.floor(Math.random() * 1000000000000) + 1;  
        const num =  Math.floor(Math.random() * 300)
        this.setState(previousState => ({
            pages: [...previousState.pages,{id:ids,icon:this.emojilit(num),name:'Untitle',url:value+"/"+ids,showIcons:false,show : false,subpage:[]}]
        }), function updateValues(){
            const params = {
                'data': this.state,
                'uid': value,
                'id' : ids,
                'emoji':num,
             };

            axios.post(process.env.REACT_APP_API_HOST+"createnewpage", params, { // receive two parameter endpoint url ,form data   
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(res => { // then print response status            
                if(res.statusText==="OK"){
                    this.props.history.push('/'+value+"/"+ids);
                }
            })

            this.props.updateStateList(this.state);
        });
    }

    onEmojiClick = (event,emojiObject) => {
        this.setState({chosenEmoji:emojiObject});
    }

    showIcon = (key) =>{
        var stateCopy = Object.assign({}, this.state);
        stateCopy.pages[key].showIcons = true;
        this.setState(stateCopy);
        console.log(key);
    }

    clickElement = (index) =>{
        var stateCopy = Object.assign({}, this.state);
        stateCopy.pages[index].show = !stateCopy.pages[index].show;
        this.setState(stateCopy);
    }


    searchItem = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].show = !stateCopy[i].show;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.searchItem(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }


    change = (id)=>{


        var stateCopy = this.searchItem(this.state.pages,id);
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
        this.setState(stateCopy2,function update(){
            const socket = socketIOClient(process.env.REACT_APP_API_HOST);
            const data = {
                uid : localStorage.getItem('uid'),
                data: this.state

            }
            socket.emit("change-title", data);
        });
    }

    changePage = (id) =>{
        this.props.changePageInMain(id);
    }


    showOptionList = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].showoption = !stateCopy[i].showoption;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.showOptionList(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }


    showMenuOption = (id)=>{

        var stateCopy = this.showOptionList(this.state.pages,id);
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
        this.setState(stateCopy2);
    }


    searchItemToAddPage = (props,id,ids,emoji) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                const value = localStorage.getItem('uid');
                stateCopy[i].show = true;               
                stateCopy[i].subpage.push({id:ids,icon:this.emojilit(emoji),name:'Untitle',url:value+"/"+ids,showIcons:false,show : false,subpage:[]})
                
                break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.searchItemToAddPage(stateCopy[i].subpage,id,ids,emoji);
                }
            }
        }

        return stateCopy;   

    }

    sleep = (milliseconds) => {
        return new Promise(resolve => setTimeout(resolve, milliseconds))
    }

     doSomething = async () => {
        await this.sleep(5000)
        //do stuff
    }
      

    createPage = (id) =>{

        const ids = Math.floor(Math.random() * 1000000000000) + 1;  

        const num =  Math.floor(Math.random() * 300)

        const value = localStorage.getItem('uid');

        var stateCopy = this.searchItemToAddPage(this.state.pages,id,ids,num);
        
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
    
        this.setState(stateCopy2,function updateValues(){

            const params = {
                'data': this.state,
                'uid': value,
                'id' : ids,
                'emoji':num
             };

            axios.post(process.env.REACT_APP_API_HOST+"createnewpage", params, { // receive two parameter endpoint url ,form data   
                headers: {
                    'content-type': 'application/json',
                },
            })
            .then(res => { // then print response status            
                if(res.statusText==="OK"){
                    this.props.history.push('/'+value+"/"+ids);
                }
            })
        });
    }


    searchItemToRemove = (props,id,parentID) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                if(parentID===null){

                    if(sz > 1){
                    
                        stateCopy.splice(i,1);
                        
                        this.parent = stateCopy[0].url;

                    }

                }else{
                    this.parent = parentID;
                    stateCopy.splice(i,1);
                }
                break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.searchItemToRemove(stateCopy[i].subpage,id,stateCopy[i].url);
                }
            }
        }

        return stateCopy;

    }
    
    createFile(id,idnew){

        const socket = socketIOClient(process.env.REACT_APP_API_HOST);

        const value = localStorage.getItem('uid');

        const inf ={
            idnew : idnew,
            uid : value,
            idlast : id


        }
        socket.emit("duplicate-page",inf);

    }

    creaFileDuplicate = (props) =>{
   

        const sz = props.length;

        var stateCopy = Object.assign([], props);

        for(var i = 0; i< sz ; i++){

            const ids = Math.floor(Math.random() * 1000000000000) + 1;  

            this.createFile(stateCopy[i].id,ids);

            stateCopy[i].id = ids;

            stateCopy[i].url = stateCopy[i].url.split("/")[0]+"/"+ids;

            if(stateCopy[i].subpage.length>0){
                stateCopy[i].subpage = this.creaFileDuplicate(stateCopy[i].subpage);
            }
            
        }

        return stateCopy;

    }

    addNewObject = (props) =>{
        
        var ob = Object.assign({}, props);
        
        ob.subpage = Object.assign([], props.subpage);

        const sz = ob.subpage.length;

        for(var i = 0;i<sz;i++){

            ob.subpage[i] = this.addNewObject(props.subpage[i]);

        }

        return ob;
    }


    searchItemToDuplicate = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                //stateCopy.splice(i,1);


                stateCopy[i].showoption = false;


                const ids = Math.floor(Math.random() * 1000000000000) + 1;  


                const x =  this.addNewObject(stateCopy[i]);

                x.id = ids;

                x.url = x.url.split("/")[0]+"/"+ids;

                this.createFile(stateCopy[i].id,ids);

                x.subpage = this.creaFileDuplicate(x.subpage);

                stateCopy.push(x);

                break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.searchItemToDuplicate(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }

    removeElement = (id) =>{


        var stateCopy = this.searchItemToRemove(this.state.pages,id,null);
        console.log(stateCopy);
        if(stateCopy.length===1 && stateCopy[0].id==id){
            return;
        }
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
        this.setState(stateCopy2,function removeItem(){
            const socket = socketIOClient(process.env.REACT_APP_API_HOST);
            const data = {
                uid : localStorage.getItem('uid'),
                data: this.state,
                id : id

            }
            socket.emit("remove-page", data);

            this.props.updateStateList(this.state);

            this.sleep(300).then(() => {
                console.log(this.state.parentID);
                this.props.history.push('/'+this.parent);
            })


        });

    }
    
    duplicateItem = (id) =>{
        console.log(id);
        var stateCopy = this.searchItemToDuplicate(this.state.pages,id);

        console.log(stateCopy);

        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);

        this.setState(stateCopy2,function updateSidebar(){
            const socket = socketIOClient(process.env.REACT_APP_API_HOST);
            const data = {
                uid : localStorage.getItem('uid'),
                data: this.state,

            }
            socket.emit("update-sidebar", data);
            this.props.updateStateList(this.state);
        });

    }

    show = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].showicon = true;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.show(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }

    hidden = (props,id) =>{

        const sz = props.length;
        var stateCopy = Object.assign([], props);
        for(var i = 0; i< sz ; i++){
            if(stateCopy[i].id===id){
                stateCopy[i].showicon = false;
                stateCopy[i].showoption = false;
               break;
            }else{
                if(stateCopy[i].subpage.length>0){
                    stateCopy[i].subpage = this.hidden(stateCopy[i].subpage,id);
                }
            }
        }

        return stateCopy;

    }

    showIcons = (id) => {
        var stateCopy = this.show(this.state.pages,id);
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
        this.setState(stateCopy2);
    } 

    hideIcons = (id) => {
        var stateCopy = this.hidden(this.state.pages,id);
        var stateCopy2 = Object.assign({}, this.state);
        stateCopy2.pages = Object.assign([],stateCopy);
        this.setState(stateCopy2);
    }


    getPartialSidebar = (pages,id) =>{

        for(var i=0;i<pages.length;i++){
            if(pages[i].id===id){
                let temp_page = Object.assign({}, pages[i]);
                pages.splice(i, 1);
                return {temp_page};
            }else{
                if(pages[i].subpage.length>0){
                   let next_page = this.getPartialSidebar(pages[i].subpage,id);
                   if(next_page!==null){
                        return next_page;
                   }

                }
            }

        }
        return null;

    }

    addElement = (pages,element_add,id) =>{

        for(var i=0;i<pages.length;i++){
            if(pages[i].id===id){
                let temp_slider = pages[i].subpage.push(element_add);
                return temp_slider;
            }else{
                if(pages[i].subpage.length>0){
                    this.addElement(pages[i].subpage,element_add,id);
                }
            }

        }    


    }

    moveElement = (id_move,id_drop) =>{

        var stateCopy = Object.assign({}, this.state);

        let {temp_page} = this.getPartialSidebar(stateCopy.pages,parseInt(id_move));
        
        let obj_end = this.addElement(stateCopy.pages,temp_page,parseInt(id_drop));

        this.setState(stateCopy);

    }


    hideSidebar = () => {

        var stateCopy2 = Object.assign({}, this.state);
        if(!stateCopy2.hidesidebar){
            stateCopy2.hidesidebar = true;
            this.setState(stateCopy2,function update(){
                this.props.updateStateList(this.state);
            });
            
        }else{
            stateCopy2.hidesidebar = false;
            this.setState(stateCopy2);
            this.setState(stateCopy2,function update(){
                this.props.updateStateList(this.state);
            });
        }
    }


    render(){


    
        
        return(
            <div className="sidebar">
                <div className="show-sidebar">
                    <Icon color="#5A687C" onClick={this.hideSidebar} path={(this.state.hidesidebar)===true?mdiArrowExpandRight:mdiArrowCollapseLeft}/>
                </div>
                <div className="workspace">
                    <span className="workspace-title">Workspace</span>
                </div>

                <div className="list-page">
                    <ListOptions active={this.props.page} showIcons={this.showIcons} hideIcons={this.hideIcons} duplicateItem={this.duplicateItem} removeElement={this.removeElement} moveElement={this.moveElement} showMenuOption={this.showMenuOption} updateState={this.changePage} addPage={this.createPage} options={this.state.pages} ChangeOption={this.change} ></ListOptions>
                </div>
               
                <div className="new-page-btn">
                    <button onClick={this.handleNewPage}>
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8.00004 14.6667V8.00004M8.00004 8.00004V1.33337M8.00004 8.00004H14.6667M8.00004 8.00004H1.33337" stroke="#5A687C" stroke-width="2" stroke-linecap="round"/>
                        </svg>
                        New Page
                    </button>
                </div>
            </div>
        );
    }


}

export default withRouter(SideBar);